// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('OldArticleNumberMappingVO')
export class OldArticleNumberMappingVO {

  @JsonProperty('articleLength', 'Number')
  public articleLength: number = undefined;
  @JsonProperty('oldArticleNumber', 'String')
  public oldArticleNumber: string = undefined;
  @JsonProperty('newArticleNumber', 'String')
  public newArticleNumber: string = undefined;
}
